module.exports = __webpack_public_path__ + "resources/img/logo_partner_game_nhn629_m.33bf3e0730493d78aec51eff0010a192.png";